/* tslint:disable */

/**
 * The type of Event Emitter from filters component
 */
type EventEmitterFilterTypes = 'PARAMS' | 'BODY' | 'SHOW_HIDE_COLUMN' | 'EXPORT';
namespace EventEmitterFilters {
  export const PARAMS: EventEmitterFilterTypes = 'PARAMS';
  export const BODY: EventEmitterFilterTypes = 'BODY';
  export const SHOW_HIDE_COLUMN: EventEmitterFilterTypes = 'SHOW_HIDE_COLUMN';
  export const EXPORT: EventEmitterFilterTypes = 'EXPORT';
  export function values(): EventEmitterFilterTypes[] {
    return [PARAMS, BODY, SHOW_HIDE_COLUMN, EXPORT];
  }
}

export { EventEmitterFilters };
